import { IonText } from "@ionic/react";
import { useSelector } from "react-redux";
import { selectLocations } from "../../../store/locations/selectors/selectLocations";

export const LocationsCount = () => {
  const locations = useSelector(selectLocations);
  const count = locations.length;
  return (
    <IonText color="primary" style={{ fontWeight: 500 }}>
      {count} {count === 1 ? "resultado" : "resultados"}
    </IonText>
  );
};
